import { useState } from "react";
import { api } from "../lib/api";
import { Lightning, ThumbsUp, ThumbsDown, BookmarkSimple } from "@phosphor-icons/react";

const KINDS = [
  { kind: "Insightful", Icon: Lightning },
  { kind: "Agree", Icon: ThumbsUp },
  { kind: "Disagree", Icon: ThumbsDown },
  { kind: "Bookmark", Icon: BookmarkSimple },
];

export default function ReactionBar({ targetType, targetId, initial, onChange, size = "sm" }) {
  const [counts, setCounts] = useState(initial?.counts || {});
  const [mine, setMine] = useState(new Set(initial?.mine || []));
  const [busy, setBusy] = useState(null);

  const toggle = async (kind) => {
    setBusy(kind);
    try {
      const { data } = await api.post("/reactions", { target_type: targetType, target_id: targetId, kind });
      setCounts(data.counts || {});
      setMine(new Set(data.mine || []));
      onChange?.(data);
    } catch (e) {
      // ignore
    } finally {
      setBusy(null);
    }
  };

  const isSm = size === "sm";

  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={`reactions-${targetType}-${targetId}`}>
      {KINDS.map(({ kind, Icon }) => {
        const active = mine.has(kind);
        const count = counts[kind] || 0;
        return (
          <button
            key={kind}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(kind); }}
            disabled={busy === kind}
            className={`flex items-center gap-1.5 border transition-colors ${isSm ? "px-2 py-1" : "px-3 py-1.5"} ${
              active
                ? "border-[#E60012] bg-[#E60012] text-white"
                : "border-[#27272A] text-zinc-400 hover:text-white hover:border-zinc-500"
            }`}
            data-testid={`reaction-${kind.toLowerCase()}-${targetType}-${targetId}`}
            title={kind}
          >
            <Icon size={isSm ? 11 : 13} weight={active ? "fill" : "regular"} />
            <span className={`label-mono`} style={{ fontSize: isSm ? 9 : 10, color: active ? "#fff" : "inherit" }}>
              {kind.toUpperCase()}
              {count > 0 && <span className="ml-1">{count}</span>}
            </span>
          </button>
        );
      })}
    </div>
  );
}
